export const placeholderStyleUrls = {
    "1x1": "https://placehold.co/1200x1200",
    "4x3": "https://placehold.co/1200x900",
    "16x9": "https://placehold.co/1280x720",
    "1080x900": "https://placehold.co/1080x900",
    "1200x900": "https://placehold.co/1200x900",
    "1248x848": "https://placehold.co/1248x848",
    "1280w": "https://placehold.co/1280",
    "1280x720": "https://placehold.co/1280x720",
    "1600w": "https://placehold.co/1600",
    "1880x1880": "https://placehold.co/1880x1880",
    "195w": "https://placehold.co/195",
    "195x195": "https://placehold.co/195x195",
    "200x140": "https://placehold.co/200x140",
    "2496x1696": "https://placehold.co/2496x1696",
    "300x210": "https://placehold.co/300x210",
    "300x300": "https://placehold.co/300x300",
    "360x300": "https://placehold.co/360x300",
    "390h": "https://placehold.co/390",
    "390x390": "https://placehold.co/390x390",
    "400h_fb": "https://placehold.co/400",
    "400w": "https://placehold.co/400",
    "400w_fb": "https://placehold.co/400",
    "400x280": "https://placehold.co/400x280",
    "420x320": "https://placehold.co/420x320",
    "440x440": "https://placehold.co/440x440",
    "470x470": "https://placehold.co/470x470",
    "600x420": "https://placehold.co/600x420",
    "600x600": "https://placehold.co/600x600",
    "624x424": "https://placehold.co/624x424",
    "720x600": "https://placehold.co/720x600",
    "790x445": "https://placehold.co/790x445",
    "800w": "https://placehold.co/800",
    "800w_fb": "https://placehold.co/800",
    "800x560": "https://placehold.co/800x560",
    "840x640": "https://placehold.co/840x640",
    "880x880": "https://placehold.co/880x880",
    "940x940": "https://placehold.co/940x940",
    crop_thumbnail: "https://placehold.co/50",
    large: "https://placehold.co/200",
    medium: "https://placehold.co/100",
    thumbnail: "https://placehold.co/50"
};
